export default __webpack_public_path__ + "static/media/hero-video-desktop.b23a69e0.jpg";